module.exports = __webpack_public_path__ + "static/media/upload-01.0b326d47.svg";